'use client';

import "@aws-amplify/ui-react/styles.css";
import Authorizer from '@/components/Authorizer';
import FullscreenSpinner from "@/components/Spinner/FullscreenSpinner";
import MobileLayout from "@/components/MobileLayout";
import { fetchAuthSession } from 'aws-amplify/auth';

import { useSearchParams } from 'next/navigation';
import { useEffect, Suspense } from "react";
import useCheckUnsupported from "@/hooks/useCheckUnsupported";

export default function LoginWrapper() {
  useCheckUnsupported();

  return <Suspense>
    <Login />
  </Suspense>;
}

function Login() {
  const searchParams = useSearchParams();

  const origin = decodeURIComponent(searchParams.toString()).replace('origin=', '').replace('&', '?');

  useEffect(() => {
    const oktaRedirectUrl = sessionStorage.getItem('scomp.oktaRedirectUrl');
  
    sessionStorage.clear();

    if (oktaRedirectUrl) {
      sessionStorage.setItem('scomp.oktaRedirectUrl', oktaRedirectUrl);
    }

    const preserved: Record<string, string> = {};

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith('seenChecks_')) {
        preserved[key] = localStorage.getItem(key)!;
      }
    }
  
    // Clear all localStorage
    localStorage.clear();
  
    // Restore preserved keys
    Object.entries(preserved).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });
  }, []);

  return (
    // Customize the authenticator more
    // @see:
    // https://ui.docs.amplify.aws/react-native/connected-components/authenticator/customization#form-field-customization
    <MobileLayout
      pageTitle='logo'
      hideTitle={true}
    >
      <Authorizer origin={origin}>
        <UserLoggedIn origin={origin} />
      </Authorizer>
    </MobileLayout>
  )
}

const UserLoggedIn = ({ origin }: { readonly origin: string }) => {
  useEffect(() => {
    (async () => {
      let isOkta = false;
      const session = await fetchAuthSession();
      const cognitoUsername = session?.tokens?.idToken?.payload['cognito:username'];
      if (typeof cognitoUsername === 'string' && cognitoUsername.startsWith('Okta_')) {
        isOkta = true;
      }

      const storedOrigin = sessionStorage.getItem('scomp.oktaRedirectUrl');
      const redirectUrl = isOkta ? (storedOrigin || '/') : (origin || '/');

      sessionStorage.removeItem('scomp.oktaRedirectUrl');

      window.location.replace(redirectUrl || '/'); 
    })();
  }, [origin]);

  return (
    <FullscreenSpinner visible={true} />
  );
}
